import { VehicleType } from 'types';
import { config } from 'config';

const allowed: { [k in VehicleType]: boolean } = {
  AUTO: true,
  UTILITAIRE: true,
  MOTO: config.ALLOW_MOTO,
  'CAMPING-CAR': config.ALLOW_LOISIR,
  CARAVANE: config.ALLOW_LOISIR,
  UNKNOWN: true,
};

export const allowDeposit = (depositType: VehicleType): boolean => {
  return allowed[depositType];
};
